// libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './styles.scss';

// Components
import CardImage from './parts/CardImage';

// Components - CardDetails
import Activity from './parts/cardDetails/Activity';
import Artwork from './parts/cardDetails/Artwork';
import Resource from './parts/cardDetails/Resource';

// Components - Action
import DefaultCardAction from './cardActions/DefaultCardAction';
import ResourceCardAction from './cardActions/ResourceCardAction';

// Props and Context
const propTypes = {
  cardType: PropTypes.oneOf(['activity', 'artwork', 'resource']).isRequired,
  horizontal: PropTypes.bool,
  image: PropTypes.string,
  resourceType: PropTypes.oneOf(['video', 'file']),
  title: PropTypes.string.isRequired,
};

const defaultProps = {
  horizontal: false,
  image: null,
  resourceType: null,
};

const contextTypes = {
  t: PropTypes.func,
};

function Card(props) {
  const {
    cardType,
    horizontal,
    image,
    resourceType,
    title,
  } = props;

  const cardComponents = {
    activity: {
      action: DefaultCardAction,
      details: Activity,
    },
    artwork: {
      action: DefaultCardAction,
      details: Artwork,
    },
    resource: {
      action: ResourceCardAction,
      details: Resource,
    },
  };
  const CardDetails = cardComponents[cardType].details;
  const ActionComponent = cardComponents[cardType].action;

  return (
    <article
      className={classNames('card', {
        'card--horizontal': horizontal,
      })}
    >
      <div className="card__wrapper">
        {(cardType !== 'resource' || resourceType === 'video') &&
          <CardImage
            image={image}
            title={title}
            resourceType={resourceType}
            actionComponent={ActionComponent}
            {...props}
          />
        }
        <div className="card__details">
          <ActionComponent className="card__link" {...props}>
            <CardDetails {...props} />
          </ActionComponent>
        </div>
      </div>
    </article>
  );
}

Card.contextTypes = contextTypes;
Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default withRouter(Card);



// WEBPACK FOOTER //
// ./src/app/components/cards/card/Card.js